import { put, call } from "redux-saga/effects";
// import get_api from "../../../../../lib/LockerSettings/GetApi";
import get_api from "../api/GetApi";
import { StaffSearchAction } from "../actions/index";
import { globalStartLoading, globalFinishLoading } from "modules/actions/Loading/index";

export function* getStaffSearchResultData(param) {
  try {
    yield put(globalStartLoading());
    const { data } = yield call(get_api.getSearchStaff, param);

    if (data.data === null) {
      yield put(StaffSearchAction.loadStaffSearchSuccess(false));
    } else {
      yield put(StaffSearchAction.loadStaffSearchSuccess(data));
    }
    yield put(globalFinishLoading());
  } catch (error) {
    console.log("from saga  -> ");
    console.log(error);
    yield put(StaffSearchAction.loadStaffSearchFail(error));
    yield put(globalFinishLoading());
  }
}
